import { Plugin } from "@hydrosoft/map-api";
import React from "react";
import Chart from "./Chart";
export class ChartPlugin extends Plugin {
    _callbacks = [];
    create(element, eventManager) {
        return React.createElement(Chart, { element: element });
    }
    getLocales(lang) {
        const locales = {
            cs: {},
            en: {},
        };
        return locales[lang];
    }
    afterRender(callback) {
        this._callbacks.push(callback);
    }
}
//# sourceMappingURL=ChartPlugin.js.map